import RandomIdObject from '@/docs-partials/api/schema/randomId-object.mdx';
import * as React from 'react';
export default {
  RandomIdObject,
  React
};